import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography } from '@mui/material'
import { useChartLegendStyles } from './styles'

interface CostChartLegendProps {
  shouldDisplayDischargeIndicator: boolean
}

export const CostChartLegend: React.FC<CostChartLegendProps> = ({ shouldDisplayDischargeIndicator }) => {
  const { classes, cx } = useChartLegendStyles()
  const { t } = useCustomTranslation()

  return (
    <Stack className={classes.container} gap={2}>
      <Stack direction="row" alignItems="center">
        <Box className={classes.squareIndicatorWrapper}>
          <Box className={cx(classes.gridIndicator, classes.squareIndicator)} />
        </Box>
        <Typography variant="body2" className={classes.indicatorLabel}>
          {t('emobility.chargingSession.grid-energy')}
        </Typography>
      </Stack>
      <Stack alignItems="center" direction="row">
        <Box className={classes.squareIndicatorWrapper}>
          <Box className={cx(classes.solarIndicator, classes.squareIndicator)} />
        </Box>
        <Typography className={classes.indicatorLabel}>{t('emobility.chargingSession.solar-energy')}</Typography>
      </Stack>
      {shouldDisplayDischargeIndicator && (
        <Stack direction="row" alignItems="center">
          <Box className={classes.squareIndicatorWrapper}>
            <Box className={cx(classes.dischargeIndicator, classes.squareIndicator)} />
          </Box>
          <Typography variant="body2" className={classes.indicatorLabel}>
            {t('emobility.chargingSession.discharged-energy-legend')}
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
